var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'is-blurred': _vm.loading,
    'is-invisible': _vm.loading && !_vm.supportsBlur
  },attrs:{"data-test":"authority"}},[_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('seo_service.sub_headings.your_website')))]),_c('progress',{staticClass:"progress is-info is-medium",attrs:{"max":_vm.max},domProps:{"value":_vm.data}},[_c('span',{staticClass:"text-in-bar",attrs:{"data-test":"score"}},[_vm._v(_vm._s(_vm.data.toFixed())+"/"+_vm._s(_vm.max))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }